export default "__VITE_ASSET__RxlIrwLt__"